import PropTypes from 'prop-types';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';

import containerWidth from '../../../../shared/helpers/containerWidth';
import normalizeCurrency, { normalizeFHA } from '../../../../shared/libs/formNormalization';
import { required } from '../../../../shared/libs/reduxFormValidations';
import InputText from '../../FormElements/Input/Input';
import InputSelect from '../../FormElements/Select/Select';

import './ThirdScreen.scss';

const FhaSelectOptions = [
  {
    label: 'Yes',
    value: 'Yes',
  },
];

function ThirdScreen({
  fha,
  config,
  handleSubmit,
}) {
  const {
    propertyType,
    reportType,
    reportPurpose,
    inspectionTypes,
    valueApproaches,
  } = useSelector((state) => ({
    ...state.dropdownLists,
  }));
  return (
    <form
      onSubmit={handleSubmit}
      className="row order_form_third"
      id="wizard-form"
    >
      <div className={containerWidth}>
        <Field
          name="propertyType"
          defaultOptions={propertyType}
          type="text"
          placeholder="Select One"
          component={InputSelect}
          label="What is the property type?"
          required={config.propertyType?.r}
          validate={[].concat(config.propertyType?.r ? [required] : [])}
          hidden={config.propertyType?.h}
        />
        <div className="row">
          <div className="col">
            <Field
              name="reportType.first"
              placeholder="Select One"
              component={InputSelect}
              defaultOptions={reportType}
              label="What is the report type?"
              required={config.reportType1?.r}
              validate={[].concat(config.reportType1?.r ? [required] : [])}
              hidden={config.reportType1?.h}
            />
          </div>
          <div className="col">
            <Field
              name="reportType.second"
              type="text"
              placeholder="Add another Report Type"
              component={InputText}
              label="&nbsp;"
              required={config.reportType2?.r}
              validate={[].concat(config.reportType2?.r ? [required] : [])}
              hidden={config.reportType2?.h}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <Field
              placeholder="Select One"
              name="inspectionType"
              component={InputSelect}
              label="Inspection Type"
              labelClassName="text-truncate col-12"
              defaultOptions={inspectionTypes}
              required={config.inspectionType?.r}
              validate={[].concat(config.inspectionType?.r ? [required] : [])}
              hidden={config.inspectionType?.h}
            />
          </div>
          <div className="col-sm-6">
            <Field
              placeholder="Select One"
              name="valueApproach"
              component={InputSelect}
              label="Value Approach"
              defaultOptions={valueApproaches}
              required={config.valueApproach?.r}
              validate={[].concat(config.valueApproach?.r ? [required] : [])}
              hidden={config.valueApproach?.h}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <Field
              name="fha"
              type="text"
              component={InputSelect}
              label="FHA"
              defaultOptions={config.fhaCaseNumber?.r
                ? FhaSelectOptions
                : FhaSelectOptions.concat({
                  label: 'No',
                  value: 'No',
                })}
              hidden={config.fhaCaseNumber?.h}
            />
          </div>
          <div className="col-sm-6">
            <Field
              name="fhaCaseNumber"
              type="text"
              component={InputText}
              label="Case #"
              disabled={fha !== 'Yes'}
              skipTouchedValidation
              normalize={normalizeFHA}
              required={config.fhaCaseNumber?.r}
              validate={[].concat(config.fhaCaseNumber?.r ? [required] : [])}
              hidden={config.fhaCaseNumber?.h}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <Field
              name="appraisalPurpose"
              type="text"
              component={InputSelect}
              label="Intended Use / Report Purpose"
              placeholder="Select One"
              labelClassName="text-truncate col-12"
              defaultOptions={reportPurpose}
              required={config.reportPurpose?.r}
              validate={[].concat(config.reportPurpose?.r ? [required] : [])}
              hidden={config.reportPurpose?.h}
            />
          </div>
          <div className="col-sm-6">
            <Field
              name="purchasePrice"
              type="text"
              component={InputText}
              label="Purchase Price"
              normalize={normalizeCurrency}
              required={config.purchasePrice?.r}
              validate={[].concat(config.purchasePrice?.r ? [required] : [])}
              hidden={config.purchasePrice?.h}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <Field
              name="loanNumber"
              type="text"
              component={InputText}
              label="Loan #"
              placeholder="If you know"
              required={config.loanNumber?.r}
              validate={[].concat(config.loanNumber?.r ? [required] : [])}
              hidden={config.loanNumber?.h}
            />
          </div>
          <div className="col-sm-6">
            <Field
              name="parcelNumber"
              type="text"
              component={InputText}
              label="APN (Parcel Number)"
              required={config.parcelNumber?.r}
              validate={[].concat(config.parcelNumber?.r ? [required] : [])}
              hidden={config.parcelNumber?.h}
            />
          </div>
        </div>
      </div>
    </form>
  );
}

ThirdScreen.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  fha: PropTypes.string,
  config: PropTypes.objectOf(PropTypes.shape({
    r: PropTypes.bool,
    h: PropTypes.bool,
  })).isRequired,
};
ThirdScreen.defaultProps = {
  fha: null,
};

const selector = formValueSelector('WizardOrderForm');
const ReachThirdScreen = connect((state) => {
  const fha = selector(state, 'fha');
  return {
    fha,
  };
})(ThirdScreen);

export default reduxForm({
  form: 'WizardOrderForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: (value) => {
    const errors = {};
    if (value.fha === 'Yes' && !value.fhaCaseNumber) {
      errors.fhaCaseNumber = 'Case # is required';
    }
    if (
      value.fha === 'Yes'
      && value.fhaCaseNumber
      && value.fhaCaseNumber.replace(/-/g, '').length !== 10
      && !Number.isNaN(errors.fhaCaseNumber)
    ) {
      errors.fhaCaseNumber = 'Case # should have 10 digits';
    }
    return errors;
  },
})(ReachThirdScreen);
